import startSentry from 'next/javascripts/sentry';
startSentry(process.env.SENTRY_JS_DESKTOP_DSN);

import './application_lib';
import './constants';
import 'javascripts/form';
import './tower';
import './mycolorway';
import './utils';
import './permission';
import './components-init';

import './components';
import './pages';

import 'next/javascripts/modules/before-page-cache'
import 'next/javascripts/modules/dompurify'
import 'next/javascripts/modules/hotkeys/global-hotkeys'

import 'next/javascripts/components/intercom-fallback';
import 'next/javascripts/components/markdown-parser';
import 'next/javascripts/components/subscriptions';

import 'next/javascripts/components/chip-set';

import 'next/javascripts/components/form-fields/text-field';
import 'next/javascripts/components/form-fields/select-field';
import 'next/javascripts/components/form-fields/checkbox-field';
import 'next/javascripts/components/form-fields/switch-field';
import 'next/javascripts/components/form-fields/radio-button-field';
import 'next/javascripts/components/form-fields/combo-select-field';
import 'next/javascripts/components/form-fields/assignee-select-field';
import 'next/javascripts/components/form-fields/date-field';
import 'next/javascripts/components/form-fields/todo-date-field';
import 'next/javascripts/components/form-fields/date-time-field';
import 'next/javascripts/components/form-fields/date-range-field';
import 'next/javascripts/components/form-fields/color-select-field';
import 'next/javascripts/components/form-fields/multiple-select-field';
import 'next/javascripts/components/form-fields/member-select-field';
import 'next/javascripts/components/form-fields/todo-assignee-select-field';
import 'next/javascripts/components/form-fields/priority-select-field';
import 'next/javascripts/components/form-fields/member-batch-select-field';
import 'next/javascripts/components/form-fields/member-scope-select-field';

import 'next/stylesheets/components/dropdown-button.scss';
import 'next/javascripts/components/menu';
import 'next/javascripts/components/nested-menu';
import 'next/javascripts/components/dialog';
import 'next/javascripts/components/block-anchor';
import 'next/javascripts/components/tabs';
import 'next/javascripts/components/tree';
import 'next/javascripts/components/table';
import 'next/javascripts/components/datatable';
import 'next/javascripts/components/pagination';
import 'next/javascripts/components/set-channel';
import 'next/javascripts/components/access-control';
import 'next/javascripts/components/list-item-form';
import 'next/javascripts/components/readable-datetime';
import 'next/javascripts/components/prototype-project-clone-card';
import 'next/javascripts/components/toast';
import 'next/javascripts/components/slide';
import 'next/javascripts/components/page/dialog-page';
import 'next/javascripts/components/page/slide-page';
import 'next/javascripts/components/calendar-container';

import 'next/javascripts/components/header-nav-item';

import 'next/javascripts/components/todos-group';
import 'next/javascripts/components/member-todo-toolbar';
import 'next/javascripts/components/member-todo-box';
import 'next/javascripts/components/member-todo-timeline-box';
import 'next/javascripts/components/trash-items-box';

import 'next/javascripts/components/user-survery';

import 'next/javascripts/components/filter-editor';
import 'next/javascripts/components/spreadsheet';

import 'next/javascripts/components/project-infos';
import 'next/javascripts/components/project-checkboxes';
import 'next/javascripts/components/project/member-change-log';
import 'next/javascripts/components/project/member-batch-invitation-form';
import 'next/javascripts/components/role/permissions-form';

import 'next/javascripts/components/webhook-form';

import 'next/javascripts/components/todo';
import 'next/javascripts/components/todolist';
import 'next/javascripts/components/todolist-plus';
import 'next/javascripts/components/todo-checklist';
import 'next/javascripts/components/todo-copyform';
import 'next/javascripts/components/todo-moveform';
import 'next/javascripts/components/todo-custom-field';

import 'next/javascripts/components/time_logs/time-field';

import 'next/javascripts/components/header';
import 'next/javascripts/components/projects';
import 'next/javascripts/components/kanban';
import 'next/javascripts/components/calendar';
import 'next/javascripts/components/docs';
import 'next/javascripts/components/members';
import 'next/javascripts/components/resource';

import 'next/javascripts/components/team-wide-id';
import 'next/javascripts/components/feature-banner';
import 'next/javascripts/components/upgrade-plan-feature';
import 'next/javascripts/components/todo-inline-form';
import 'next/javascripts/components/circle-progress-bar';
import 'next/javascripts/components/project-progress-form';
import 'next/javascripts/components/project-progress-filter';
import 'next/javascripts/components/project-progress-status-form';
import 'next/javascripts/components/project-progress-status';
import 'next/javascripts/components/project-progress-detail';
import 'next/javascripts/components/remind-assignee-form';
import 'next/javascripts/components/advertisement-banner';
import 'next/javascripts/components/calendar-todo-form';

import 'next/javascripts/components/operation-logs-filter';
import 'next/javascripts/components/feature-dialog';

import 'next/javascripts/components/todo-page';

import 'next/javascripts/components/project/creation';

import 'next/javascripts/components/project/table-view';
import 'next/javascripts/components/project/table-view-toolbar';
import 'next/javascripts/components/project/todo-desc-edit-dialog';
import 'next/javascripts/components/project/list-view-batch-operation-bar';

import 'next/javascripts/components/project/topic/list';

import 'next/javascripts/components/project/attachment-center/list';

import 'next/javascripts/components/table-view/todo-table/element';

import 'next/javascripts/components/mobile-verification';
import 'next/javascripts/components/teams/trial-plans';
import 'next/javascripts/components/teams/preparation';
import 'next/javascripts/components/teams/init-scene';
import 'next/javascripts/components/teams/dashboards/delay-todo-statistics-table.js';
import 'next/javascripts/components/users/wechat-qrcode-sign-up';
import 'next/javascripts/components/users/wechat-qrcode-verifier';

import 'next/javascripts/components/lazy-load';

import 'next/javascripts/components/field-prototype-form';
import 'next/javascripts/components/field-prototype-list';
import 'next/javascripts/components/field-prototype-setting';

import 'next/javascripts/components/feature-popover';
import 'next/javascripts/components/attachments-list';
import 'next/javascripts/components/editor';
import 'next/javascripts/components/editor/output-renderer';
import 'next/javascripts/components/markdown-editor';
import 'next/javascripts/components/document-editor';
import 'next/javascripts/components/document-edit-button';

import 'next/javascripts/components/sticky-panel';
import 'next/javascripts/components/comments';
import 'next/javascripts/components/comment-fake-form';
import 'next/javascripts/components/comment-form';
import 'next/javascripts/components/todo/desc-form';
import 'next/javascripts/components/topic-form';
import 'next/javascripts/components/reports/answer-form';
import 'next/javascripts/components/zoom';
import 'next/javascripts/components/draft-confirmation';

import 'next/javascripts/components/team-wide-id';
import 'next/javascripts/components/resource-card';
import 'next/javascripts/components/document-toc';

import 'next/javascripts/components/editing-presence';
import 'next/javascripts/components/edit-status';

import 'next/javascripts/logrocket';

import 'next/javascripts/components/fullscreen-page';
import 'next/javascripts/components/fullscreen-overlay';
import 'next/javascripts/components/identity-verifier';
import 'next/javascripts/components/identity-verifier-wrapper';

import 'next/javascripts/components/scroll-load-trigger';

import 'next/javascripts/components/hyperlink-field-value-form-dialog';
import 'next/javascripts/components/grid';
import 'next/javascripts/components/area-line-chart';
import 'next/javascripts/components/portfolio/fields';
import 'next/javascripts/components/portfolio/field-dialog';
import 'next/javascripts/components/project-progress-custom-field';
import 'next/javascripts/components/destroy-custom-field-dialog';
import 'next/javascripts/components/mini-slideshow';

import 'tr_wework/javascripts/teams';
import 'tr_import/javascripts';
import 'next/javascripts/components/feature-video-guide';
import 'next/javascripts/components/feature-unboxing-video';
import 'next/javascripts/components/context-tooltip';
import 'next/javascripts/triggered-guide/index';
import 'next/javascripts/components/todo-labels-begin-edit-trigger';
import 'next/javascripts/components/project-list-view-trigger';
import 'next/javascripts/components/project-kanban-trigger';
import 'next/javascripts/components/project-timeline-trigger';
import 'next/javascripts/components/project-calendar-view-trigger';
import 'next/javascripts/components/feature-blank-content';
import 'next/javascripts/components/formatted-number';
import 'next/javascripts/components/account-setup';
import 'next/javascripts/components/list-project-preview-grid';
import 'next/javascripts/components/board-project-preview-board';
import 'next/javascripts/components/timeline-project-preview-timeline';
import 'next/javascripts/components/calendar-project-preview-calendar';